import '../scss/default.scss';

import * as bootstrap from 'bootstrap';